import { Typography } from '@mui/material';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const DragDrop = ({
  data,
  setData,
  heading
}) => {

  const onDragEnd = (result) => {
    const { destination, source } = result;

    // If dropped outside of any droppable area
    if (!destination) return;

    // Moving within the same column
    if (destination.droppableId === source.droppableId) {
      const column = data.columns[source.droppableId];
      const newTaskIds = Array.from(column.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, result.draggableId);

      const newColumn = {
        ...column,
        taskIds: newTaskIds,
      };

      setData((prevData) => ({
        ...prevData,
        columns: {
          ...prevData.columns,
          [newColumn.id]: newColumn,
        },
      }));
    } else {
      // Moving between different columns
      const startColumn = data.columns[source.droppableId];
      const endColumn = data.columns[destination.droppableId];

      const startTaskIds = Array.from(startColumn.taskIds);
      startTaskIds.splice(source.index, 1);

      const endTaskIds = Array.from(endColumn.taskIds);
      endTaskIds.splice(destination.index, 0, result.draggableId);

      const newStartColumn = {
        ...startColumn,
        taskIds: startTaskIds,
      };

      const newEndColumn = {
        ...endColumn,
        taskIds: endTaskIds,
      };

      setData((prevData) => ({
        ...prevData,
        columns: {
          ...prevData.columns,
          [newStartColumn.id]: newStartColumn,
          [newEndColumn.id]: newEndColumn,
        },
      }));
    }
  };

  return (
    heading ? (
      <DragDropContext onDragEnd={onDragEnd}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

          {/* Full-width first column */}
          {(() => {
            const firstColumn = Object.values(data.columns)[0];
            return (
              <Droppable droppableId={firstColumn.id} key={firstColumn.id} direction="vertical">
                {(provided) => (
                  <div style={{ width: '99%' }}>
                    <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                      {firstColumn.title}
                    </Typography>
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        border: '1px dashed #ccc',
                        minHeight: 25,
                        padding: 10,
                      }}
                    >
                      {firstColumn.taskIds.map((taskId, index) => {
                        const task = data.tasks.find((t) => t.id === taskId);
                        return (
                          <Draggable draggableId={task.id} index={index} key={task.id}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  padding: '5px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 5,
                                  border: '1px solid #ddd',
                                  marginBottom: 5,
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <DragHandleIcon />
                                <Typography variant="body2">{task.content}</Typography>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  </div>
                )}
              </Droppable>
            );
          })()}

          {/* Grid for remaining columns: 3 per row */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {Object.values(data.columns)
              .slice(1) // Skip first column
              .map((column) => (
                <Droppable droppableId={column.id} key={column.id} direction="vertical">
                  {(provided) => (
                    <div style={{ width: '30%', minWidth:  Object.keys(data.columns)?.length === 3 ? '305px': '200px' }}>
                      <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                        {column.title}
                      </Typography>
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                          border: '1px dashed #ccc',
                          minHeight: 25,
                          padding: 10,
                        }}
                      >
                        {column.taskIds.map((taskId, index) => {
                          const task = data.tasks.find((t) => t.id === taskId);
                          return (
                            <Draggable draggableId={task.id} index={index} key={task.id}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    padding: '5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 5,
                                    border: '1px solid #ddd',
                                    marginBottom: 5,
                                    ...provided.draggableProps.style,
                                  }}
                                >
                                  <DragHandleIcon />
                                  <Typography variant="body2">{task.content}</Typography>
                                </div>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </div>
                    </div>
                  )}
                </Droppable>
              ))}
          </div>
        </div>
      </DragDropContext>

    )
      : (
        <DragDropContext onDragEnd={onDragEnd}>
          <div style={{ display: 'flex' }}>
            {Object.values(data.columns).map((column, index) => (
              <Droppable droppableId={column.id} key={column.id} direction="vertical" isDropDisabled={false}>
                {(provided) => (
                  <div style={{ margin: '0px 10px 0px 0px' }}>
                    <Typography variant='body2' style={{ fontWeight: 'bold' }}>{column.title}</Typography>
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        border: '1px dashed #ccc',
                        width: 450,
                        minHeight: 25,
                        padding: 10,
                      }}
                    >
                      {column.taskIds.map((taskId, index) => {
                        const task = data.tasks.find((t) => t.id === taskId);
                        return (
                          <Draggable draggableId={task.id} index={index} key={task.id}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  padding: '5px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 5,
                                  border: '1px solid #ddd',
                                  marginBottom: 5,
                                  ...provided.draggableProps.style,
                                }}
                              >
                                <DragHandleIcon />
                                <Typography variant='body2'>{task.content}</Typography>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  </div>
                )}
              </Droppable>
            ))}
          </div>
        </DragDropContext>
      )
  );
};

export default DragDrop;